import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import c from 'classnames';
import Fade from 'react-reveal/Fade';
import { Button } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const Modal = ({ fullScreen, visible, children, toggle }) => {
  const [show, setShow] = useState(visible);
  const classes = c('Modal', {
    fullScreen: fullScreen,
    visible: visible,
  });

  const mapVisible = useSelector((state) => state.getIn(['ui', 'map', 'visible'], false));
  const closeButtonClasses = c('CloseButton', {
    dark: mapVisible,
  });

  // Keep the visible prop and local state in sync.
  useEffect(() => {
    setShow(visible);
  }, [visible]);

  // Remove the modal from the dom if nothing needs to be rendered.
  if (!visible) {
    return null;
  }

  // We toggle() with a delay, so we have time to fade out.
  const onToggle = () => {
    setShow(!visible);
    setTimeout(() => {
      toggle();
    }, 1000); // Regular fadeout duration is 1000 ms.
  };

  return (
    <Fade when={show}>
      <div className={classes}>
        <Button
          className={closeButtonClasses}
          onClick={() => onToggle()}
          empty
        >
          Sluit <i className="icon icon-cross icon-variant-2" />
        </Button>
        <div className="Modal__content">
          { children }
        </div>
      </div>
    </Fade>
  );
};

export default Modal;
